import { render, staticRenderFns } from "./DropshipPopover.vue?vue&type=template&id=50e3c828&scoped=true&"
import script from "./DropshipPopover.vue?vue&type=script&lang=js&"
export * from "./DropshipPopover.vue?vue&type=script&lang=js&"
import style0 from "./DropshipPopover.vue?vue&type=style&index=0&id=50e3c828&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e3c828",
  null
  
)

export default component.exports